import { useMutation, useQuery } from "@tanstack/react-query";
import {
  StudyICFSelectAllParams,
  volunteerStudyICFInfo,
} from "modules/Volunteer/AssigningStudyModule/StudyICF/api/volunteerStudyICFInfo.api";
import { GetUserData } from "common/service/CommonService";

interface ApiResponse<T = any> {
  data: T;
  message: string;
  statusCode: number;
}

// ------------------------------------------------------------------
//-- Volunteer
// ------------------------------------------------------------------

export const useVolunteerStudyICF = ({
  otherid,
  searchText,
  pageNumber = 1,
  pageSize = 10,
  volunteerid,
  studyid,
}: StudyICFSelectAllParams = {}) => {
  const SelectAllQuery = useQuery({
    queryKey: [
      "volunteer-study-icf-selectAll",
      {
        otherid,
        searchText,
        pageNumber,
        pageSize,

        volunteerid,
        studyid,
      },
    ],
    queryFn: () =>
      volunteerStudyICFInfo.getSelectAllData({
        otherid,
        searchText,
        pageNumber,
        pageSize,
        volunteerid,
        studyid,
      }),
    enabled: !!(pageNumber && pageSize && volunteerid),
  });

  const InsertMutation = useMutation<ApiResponse, Error, FormData>({
    mutationFn: (payload: FormData) =>
      volunteerStudyICFInfo.insertData(payload),
  });

  return {
    SelectAllQuery,
    InsertMutation,
  };
};
